<div class="modal-header" hsDraggable="modal-dialog">
  <h4 class="modal-title">Edit Transaction Label</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    (click)="activeModal.dismiss()"
  >
    Close
  </button>
</div>
<div class="modal-body" hsDraggable="modal-dialog" *nfLoader="formSubmitting">
  <form>
    <nf-form-control>
      <div class="d-flex align-items-center">
        <label>Labels:</label>
        <ng-select
          [loading]="labelLoaded"
          [formControl]="select"
          class="select-input"
          (change)="onChange()"
          [items]="typeLabel"
          bindLabel="name"
        ></ng-select>
      </div>
    </nf-form-control>
  </form>
</div>
<div class="modal-footer" hsDraggable="modal-dialog">
  <div>
    <button nf-button="cancel" (click)="activeModal.dismiss()"></button>
    <button
      nf-button="save"
      (click)="save()"
      [disabled]="!isLabelSelected"
    ></button>
  </div>
</div>
